import { normalize, denormalize, schema } from "normalizr";

const users = new schema.Entity("users");
const types = new schema.Entity("types");
const subLocations = new schema.Entity("sub_locations");
const locations = new schema.Entity("locations");
const jobs = new schema.Entity("jobs",{},{ idAttribute: "vanity_id" });
const companies = new schema.Entity("companies");
const stats = new schema.Entity("stats",{},{ idAttribute: "sid" });

const entities = {
    users,
    types,
    locations,
    subLocations,
    jobs,
    companies,
    stats,
}

export const normalizeData = (data,type) => {
    return normalize(data,{
        data: [entities[type]],
    });
}

export const denormalizeData = (data, dataIds, type) => {
    return denormalize({[type]: dataIds},{[type]: [entities[type]]},{[type]: data});
}


// WEBPACK FOOTER //
// ./src/Schemas/index.js